import { gql } from '@apollo/client';

export const GET_TMS_TASK_BY_ID = gql`
  query GetTmsTaskById($id: ID!) {
    getTmsTaskById(id: $id) {
      id
      taskNumber
      taskType
      taskDate
      taskStatus
    }
  }
`;

export interface TmsTaskType {
  id: string;
  taskNumber: string;
  taskType: number;
  taskDate: string;
  taskStatus: number;
}

export interface GetTmsTaskByIdResponse {
  getTmsTaskById: TmsTaskType | null;
}

